define('front',[
    'jquery',
    'underscore',
    'event-manager',
    'lib',
    'front-tracking',
    'drfront-experiment-tracker',
    'jsx!components/lists/section',
    'lazy-loader'
], function(
    $,
    _,
    eventManager,
    lib,
    FrontTracking,
    ExperimentTracker,
    SectionList,
    LazyLoader
) {
    'use strict';

    eventManager.on('e24-front-loaded', function() {
        // Attach click.vgnett.no-tracking
        FrontTracking();
        ExperimentTracker();

        // Temp fix for app not reloading front page
        if (lib.isApp() && lib.$body().hasClass('front')) {
            var time = + new Date();
            setInterval(function() {
                if (new Date()-time > 900000) {
                    location.reload();
                }
            }, 6000);
        }

        SectionList(document.getElementById('sectionArticles'), {});
    });

    // Embed front on scroll
    eventManager.on('e24-article-loaded e24-podcast-loaded', function() {
        var path = '/';

        if (lib.$html().hasClass('section-detnyenorge')) {
            path += 'det-nye-norge';
        }

        $(function() {
            new LazyLoader({
                on: lib.$('#frontEmbed'),
                threshold: 400,
                callback: function() {
                    $.get(lib.getBasePath() + path, {
                        embed: 1
                    }).done(function(data) {
                        lib.$('#frontEmbed').append(data).find('.e24-spinner').remove();
                        eventManager.emit('e24-front-loaded');
                        eventManager.emit('e24-front-embed-loaded');
                        eventManager.emit('e24-widgets-render');
                        eventManager.emit('e24-find-lazy-loads');
                    });
                }
            });
        });
    });
});

